import { QueryCache, QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";

import { shouldRetryQuery } from "./query-helpers";

export const queryClient = new QueryClient({
    queryCache: new QueryCache({}),
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            gcTime: 1000 * 60 * 15, // 15 minutes
            retry: shouldRetryQuery,
            refetchOnWindowFocus: import.meta.env.PROD, // Only in production
        },
    },
});

export const QueryClientProvider = ({ children }: { children: React.ReactNode }) => {
    return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
};
